import type { RnbCalculatorPayload } from 'typings'
import type { Storefront } from '../../../typings'

type APIStorefrontPayload = Pick<
  Partial<RnbCalculatorPayload>,
  'isFeatured' | 'generalValues'
>

export function toAPIStorefront(storefront: Storefront): APIStorefrontPayload {
  return {
    isFeatured: storefront.highlight,
    generalValues: storefront.additionalInformation.length
      ? storefront.additionalInformation.reduce((acc, entry) => {
          acc[entry.name] = entry.value
          return acc
        }, {} as Record<string, string>)
      : undefined,
  }
}
